import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loader = new BehaviorSubject<boolean>(false);
  loading$ = this.loader.asObservable();

  public showLoader(): void {
    this.loader.next(true);
  }

  public hideLoader(): void {
    this.loader.next(false);
  }

  public get spinnerStatus(): Observable<boolean> {
    return this.loader.asObservable();
  }

  public wrapPromise<T>(promise: () => Promise<T>): Promise<T> {
    this.showLoader();
    return promise().then(r => {
      this.hideLoader();
      return r;
    }, (e) => {
      this.hideLoader();
      return e;
    });
  }
}
